export default function SalesBulkBar({
  visibleIds,
  selectedIds,
  onToggleAll,
  onDelete,
  deleteLabel,
  testId,
}) {
  const visible = visibleIds || [];
  const selected = selectedIds || [];
  const allOn = visible.length > 0 && visible.every((id) => selected.includes(id));
  const count = selected.length;
  return (
    <div className="sales-bulk-bar" data-testid={testId || "sales-bulk-bar"}>
      <label className="sales-bulk-bar__all">
        <input
          type="checkbox"
          checked={allOn}
          disabled={visible.length === 0}
          onChange={() => onToggleAll(!allOn)}
          data-testid="sales-bulk-select-all"
        />
        전체 선택
      </label>
      {count > 0 ? (
        <>
          <span className="sales-bulk-bar__count" data-testid="sales-bulk-count">{count}개 선택됨</span>
          <button type="button" className="sales-bulk-bar__delete" onClick={onDelete} data-testid="sales-bulk-delete">
            {deleteLabel}
          </button>
        </>
      ) : null}
    </div>
  );
}

export function toggleId(list, id, on) {
  const set = new Set(list || []);
  if (on) set.add(id);
  else set.delete(id);
  return Array.from(set);
}

export function formatBatchToast(_noun, data) {
  if (typeof data?.message === "string" && data.message.trim()) return data.message;
  const deleted = data?.deleted_count || 0;
  const requested = data?.requested_count || 0;
  const failed = data?.failed || [];
  const selected = data?.selected_count || deleted + requested + failed.length;
  const contractN = failed.filter((row) => String(row?.reason || "").includes("연결된 계약")).length;
  const consultN = failed.filter((row) => String(row?.reason || "").includes("연결된 견적")).length;
  const otherN = Math.max(0, failed.length - contractN - consultN);
  const lines = [];
  if (deleted && (failed.length || requested || selected !== deleted)) {
    lines.push(`${selected}건 중 ${deleted}건을 삭제했습니다.`);
  } else if (deleted) {
    lines.push(`${deleted}건을 삭제했습니다.`);
  }
  if (requested) lines.push(`${requested}건 삭제 요청을 등록했습니다. 관리자 승인 후 처리됩니다.`);
  if (contractN) lines.push(`${contractN}건은 연결된 계약이 있어 삭제하지 않았습니다.`);
  if (consultN) lines.push(`${consultN}건은 연결된 견적 또는 계약이 있어 삭제하지 않았습니다.`);
  if (otherN) lines.push(`${otherN}건은 삭제하지 못했습니다.`);
  if (!lines.length) return "처리할 항목이 없습니다.";
  return lines.join("\n\n");
}
